import React from 'react';
import './title.css';

function Title(props) {
  return <h1 className="title-component">{props.title}</h1>;
}

export default Title;
